import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/archive";

export function invPaperStat(criteria) {
  return request({
    url: prefix + '/invPaperStat',
    method: 'post',
    data: criteria,
  })
}


export function pageList(criteria) {
  return request({
    url: prefix + '/paper/pagelist',
    method: 'post',
    data: criteria,
  })
}


// 上传文件
export function uploadFile(data) {
  let token = data.get("token")
  let path = prefix + '/uploadFile'
  if(token){
    path = path + "?token=" + token
  }
  return request({
    url: path,
    method: 'post',
    data: data,
    timeout: 300000
  })
}

export function eidownloads(criteria) {
  return request({
    url: prefix + '/downloadZip',
    method: 'post',
    data: criteria,
    responseType: 'blob' 
  })
}
